module.exports = __webpack_public_path__ + "static/lastgen-co2-intro-7ab30670d03f3fa87ef2830e3a4ca533.mp4";